const getAdditionalDataValues = (additionalData) => {
    if (!additionalData) {
        return
    }
    const additionalHeaders = {}
    _.each(['gt', 'gte', 'lt', 'lte', 'eq', 'neq', 'notin', 'in', 'like', 'unlike', 'null', 'notnull', 'exists', 'notexists', 'columns'], (field) => {
        if (additionalData[field]) {
            const array = _.isArray(additionalData[field]) ? additionalData[field] : [additionalData[field]]
            if (array.length) {
                additionalHeaders[`x-${field}`] = array.join(';')
            }
        }
    })
    return additionalHeaders
}

angular.module('unergie.main')
    .factory('DataAccessSearch', ($resource) => {
        return (additionalData = {}) =>
            $resource(
                'search', {}, {
                    search: {
                        url: '/api/:resource/search',
                        method: 'GET',
                        isArray: true,
                        headers: {'x-order-by': additionalData.orderBy, 'x-limit': additionalData.limit},
                    },
                    searchPaginated: {
                        url: '/api/:resource/search',
                        method: 'GET',
                        headers: _.assign({
                            'x-order-by': additionalData.orderBy,
                            'x-limit': additionalData.limit,
                            'x-offset': additionalData.offset || 0,
                        }, getAdditionalDataValues(additionalData)),
                        transformResponse(data, headers) {
                            const response = {}
                            response.results = JSON.parse(data)
                            response.headers = headers()
                            return response
                        },
                    },
                    count: {
                        url: '/api/:resource/count-search',
                        method: 'GET',
                        headers: getAdditionalDataValues(additionalData),
                    },
                    searchPaginatedCsv: {
                        url: '/api/:resource/search',
                        method: 'GET',
                        responseType: 'arraybuffer',
                        headers: _.assign({
                            'x-order-by': additionalData.orderBy,
                            'x-limit': additionalData.limit,
                            'x-offset': additionalData.offset,
                            'accept': 'text/csv',
                        }, getAdditionalDataValues(additionalData)),
                        transformResponse(data, headers) {
                            const file = new Blob([data], {
                                type: 'text/csv',
                            })
                            return {
                                response: file,
                                filename: headers().filename,
                            }
                        },
                    },
                },
            )
    }).factory('ApiContentSearch', ($resource) => {
    return (additionalData = {}) =>
        $resource(
            'search', {}, {
                searchPaginated: {
                    url: '/api-content/:resource/search',
                    method: 'GET',
                    headers: _.assign({
                        'x-order-by': additionalData.orderBy,
                        'x-limit': additionalData.limit,
                        'x-offset': additionalData.offset || 0,
                        'x-count': true,
                    }, getAdditionalDataValues(additionalData)),
                    transformResponse(data, headers) {
                        const response = {}
                        response.results = JSON.parse(data)
                        response.headers = headers()
                        return response
                    },
                },
            },
        )
}).factory('DataAccess', ($resource) =>
    $resource(
        'all', {}, {
            myInfo: {
                url: '/api/accounts/:id_account/info',
                method: 'GET',
            },
            accountInfoLight: {
                url: '/api/accounts/:id_account/info-light',
                method: 'GET',
            },
            contractInfoLight: {
                url: '/api/accounts/:id_account/contracts/:id_contract/info-light',
                method: 'GET',
            },
            contractElecInfoLight: {
                url: '/api/accounts/:id_account/contracts-elec/:id_contract/info-light',
                method: 'GET',
            },
            contractGasInfoLight: {
                url: '/api/accounts/:id_account/contracts-gas/:id_contract/info-light',
                method: 'GET',
            },
            potBalance: {
                url: '/api/accounts/:id_account/pot-balance',
                method: 'GET',
            },
            potHistory: {
                url: '/api/accounts/:id_account/pot-history',
                method: 'GET',
                isArray: true,
            },
            cases: {
                url: '/api/accounts/:id_account/contracts/:id_contract/cases',
                method: 'GET',
                isArray: true,
            },
            casesElecSearch: {
                url: '/api/cases/search',
                method: 'GET',
                isArray: true,
            },
            features: {
                url: '/api/accounts/:id_account/feature-group',
                method: 'GET',
            },
            account: {
                url: '/api/accounts/:id_account',
                method: 'GET',
            },
            accountAndContracts: {
                url: '/api/accounts/:id_account?withRelated=contractsElec.prm',
                method: 'GET',
            },
            users: {
                url: '/api/users',
                method: 'GET',
                isArray: true,
            },
            updateCampaignTracking: {
                url: '/api/campaign-trackings/:id',
                method: 'PUT',
            },
            deleteUser: {
                url: '/api/users/:id_account',
                method: 'DELETE',
            },
            accountForContract: {
                url: '/api/contracts/:id_contract/account',
                method: 'GET',
            },
            contracts: {
                url: '/api/contracts?withRelated=account,prm,vendor',
                method: 'GET',
                isArray: true,
            },
            contract: {
                url: '/api/contracts/:id',
                method: 'GET',
            },
            contractWithRelated: {
                url: '/api/contracts/:id?withRelated=contractBalance,prm,providerOffer',
                method: 'GET',
            },
            modifyContract: {
                url: '/api/contracts/:id',
                method: 'PUT',
            },
            contractTimetables: {
                url: '/api/contracts/:id_contract?withRelated=timetable.payment',
                method: 'GET',
            },
            contractTimetablesWithModif: {
                url: '/api/contracts/:id_contract/timetable/modifs?withRelated=payment,date',
                method: 'GET',
                isArray: true,
            },
            updateUserFeature: {
                url: '/api/user-features/:id',
                method: 'PUT',
            },
            addUserFeature: {
                url: '/api/user-features',
                method: 'POST',
            },
            addCreditToPot: {
                url: '/api/pot/credit',
                method: 'POST',
            },
            contractDrafts: {
                url: '/api/contractdrafts/search',
                method: 'GET',
                isArray: true,
                headers: {'x-neq': 'status=10', 'x-order-by': '-modification_ts,-creation_ts'},
            },
            getDraftById: {
                url: '/api/contractdrafts/:idDraft',
                method: 'GET',
            },
            userDraft: {
                url: '/api/my-contract-draft/:idAccount',
                method: 'GET',
            },
            updateUserDraft: {
                url: '/api/my-contract-draft/:idAccount',
                method: 'PUT',
            },
            createVendorDraft: {
                url: '/api/vendor-draft',
                method: 'GET',
            },
            vendorDraft: {
                url: '/api/my-contract-draft',
                method: 'GET',
            },
            updateVendorDraft: {
                url: '/api/my-contract-draft',
                method: 'PUT',
            },
            updateDraftById: {
                url: '/api/contractdraft/:id',
                method: 'PUT',
            },
            resetVendorDraft: {
                url: '/api/my-contract-draft',
                method: 'DELETE',
            },
            draftSelfReport: {
                url: '/api/admin/accounts/:idAccount/contractdrafts/:idDraft/self-report',
                method: 'POST',
                isArray: true,
            },
            searchReadings: {
                url: '/api/readings/search',
                method: 'GET',
                isArray: true,
                headers: {
                    'x-neq': 'internal_status=90',
                    'x-order-by': 'end_date,-temp_class',
                    'x-notin': 'distributor_status=CANCELLED,CANCELED,IGNORED,IGNORE'
                },
            },
            searchReadingsGas: {
                url: '/api/readings-gas/search',
                method: 'GET',
                isArray: true,
                headers: {
                    'x-neq': 'internal_status=90',
                    'x-order-by': 'end_date,-temp_class',
                    'x-notin': 'distributor_status=CANCELLED,CANCELED,IGNORED,IGNORE'
                },
            },
            searchTimeTables: {
                url: '/api/payment-timetable-with-modifs?withRelated=payment,contractElec.account',
                method: 'GET',
                isArray: true,
            },
            accountStats: {
                url: '/api/accounts/stats',
                method: 'GET',
                isArray: true,
            },
            checkAccount: {
                url: '/api/accounts/:id/check',
                method: 'GET',
            },
            contractStats: {
                url: '/api/contracts/stats',
                method: 'GET',
                isArray: true,
            },
            supervisionContracts: {
                url: '/api/supervision/contracts',
                method: 'GET',
                isArray: false,
            },
            supervisionAccounts: {
                url: '/api/supervision/accounts',
                method: 'GET',
                isArray: false,
            },
            supervisionOdoo: {
                url: '/api/supervision/odoo-sync',
                method: 'GET',
                isArray: false,
            },
            deals: {
                url: '/api/deals',
                method: 'GET',
                isArray: true,
            },
            changeDealOwner: {
                url: '/api/deals/:id/change-owner',
                method: 'POST',
            },
            updatePaymentDay: {
                url: '/api/accounts/:id_account/billing-acc/payment-day',
                method: 'PUT',
            },
            updateSleeking: {
                url: '/api/accounts/:id_account/billing-acc/sleeking',
                method: 'PUT',
            },
            sleekIt: {
                url: '/api/contracts/:id_contract/timetable/sleek',
                method: 'POST',
            },
            updateRecurrentCb: {
                url: '/api/accounts/:id_account/billing-acc/recurrent-cb',
                method: 'PUT',
            },
            removeCardAlias: {
                url: '/api/accounts/:id_account/billing-acc/card-alias',
                method: 'DELETE',
            },
            removeMandate: {
                url: '/api/accounts/:id_account/billing-acc/mandate',
                method: 'DELETE',
            },
            updateNotif: {
                url: '/api/accounts/:id_account/billing-acc/notifications',
                method: 'PUT',
            },
            getEventRulesRef: {
                url: '/api/ref-event-rules',
                method: 'GET',
            },
            getEventRules: {
                url: '/api/event-rules/search',
                method: 'GET',
                isArray: true,
            },
            addEventRules: {
                url: '/api/event-rules',
                method: 'POST',
            },
            saveEventRules: {
                url: '/api/event-rules/:id',
                method: 'PUT',
            },
            deleteEventRules: {
                url: '/api/event-rules/:id',
                method: 'DELETE',
            },
            addContact: {
                url: '/api/contacts',
                method: 'POST',
            },
            deleteContact: {
                url: '/api/contacts/:id',
                method: 'DELETE',
            },
            contractsNeedingAttention: {
                url: '/api/contracts/needing-attention',
                method: 'GET',
                isArray: true,
            },
            contractsOverdues: {
                url: '/api/contracts/overdues',
                method: 'GET',
                isArray: true,
            },
            affectContract: {
                url: '/api/contract-affectations',
                method: 'POST',
            },
            takeActionOnAffectation: {
                url: '/api/contract-affectations/:id/action',
                method: 'PUT',
            },
            changeContractStatus: {
                url: '/api/contracts/:id_contract/status/:status',
                method: 'PUT',
            },
            markContractLost: {
                url: '/api/contracts/:id_contract/mark-lost',
                method: 'PUT',
            },
            changeContractSubType: {
                url: '/api/contracts/:id_contract/sub-type',
                method: 'PUT',
            },
            accountBalances: {
                url: '/api/account/:id_account/balance',
                method: 'GET',
            },
            regularizeBalance: {
                url: '/api/contracts/:id_contract/regularize',
                method: 'POST',
            },
            reimburseContract: {
                url: '/api/contracts/:id_contract/reimburse',
                method: 'POST',
            },
            updatePrmAddress: {
                url: '/api/prms/:id/actualAddress',
                method: 'PUT',
            },
            activeOverdueProcessOnContract: {
                url: '/api/overdue-processes/search',
                method: 'GET',
                isArray: true,
                headers: {
                    'x-unlike': 'status=CANCELLED_;status=FINISHED_',
                    'x-neq': 'status=TERMINATION_NOTIF_SENT',
                },
            },
            getEscalationList: {
                url: '/api/escalation-list',
                method: 'GET',
                isArray: true,
            },
            traceExternalPayment: {
                url: '/api/external-payment',
                method: 'POST',
            },
            saveEnergyCheck: {
                url: '/api/energy-check',
                method: 'POST',
            },
            saveFsl: {
                url: '/api/fsls',
                method: 'POST',
            },
            updateFsl: {
                url: '/api/fsls/:id',
                method: 'PUT',
            },
            validateExternalPayment: {
                url: '/api/external-payment/:id/validation',
                method: 'PUT',
            },
            contractBalance: {
                url: '/api/contract-balance/:id_contract',
                method: 'GET',
            },
            depositBalance: {
                url: '/api/contracts/:id_contract/deposit-balance',
                method: 'GET',
            },
            depositBurn: {
                url: '/api/contracts/:id_contract/deposit-burn',
                method: 'POST',
            },
            energyCheckBurn: {
                url: '/api/energy-check/burn',
                method: 'POST',
            },
            isDepositNeeded: {
                url: '/api/contracts/:id_contract/deposit-needed',
                method: 'GET',
            },
            getDepositFlag: {
                url: '/api/contracts/:id_contract/deposit-flag',
                method: 'GET',
            },
            modifyPayment: {
                url: '/api/payments/:id_payment',
                method: 'PUT',
            },
            modifyPaymentStatus: {
                url: '/api/payments/:id_payment/status',
                method: 'PUT',
            },
            cancelInitialPayment: {
                url: '/api/payments/:id_payment',
                method: 'DELETE',
            },
            createAdjustment: {
                url: '/api/contracts/:id_contract/manual-adjustment',
                method: 'POST',
            },
            deleteAdjustment: {
                url: '/api/manual-adjustments/:id',
                method: 'DELETE',
            },
            contractReadings: {
                url: '/api/contracts/:id_contract/readings',
                method: 'GET',
                isArray: true,
            },
            myAffectations: {
                url: '/api/my-affectations',
                method: 'GET',
                isArray: true,
            },
            myAffectables: {
                url: '/api/my-affectables',
                method: 'GET',
                isArray: true,
            },
            affectAccount: {
                url: '/api/account-affectations',
                method: 'POST',
            },
            unAffectAccount: {
                url: '/api/account-affectations/:id_affectation',
                method: 'DELETE',
            },
            getUserAffectations: {
                url: '/api/account/:id_account/affectations',
                method: 'GET',
                isArray: true,
            },
            modifyAccountAffectations: {
                url: '/api/account/:id_account/affectations',
                method: 'PUT',
            },
            getRefContractCategory: {
                url: '/api/ref-contract-category/:id_category',
                method: 'GET',
            },
            getRefContractCategories: {
                url: '/api/ref-contract-category',
                method: 'GET',
                isArray: true,
            },
            deleteRefContractCategory: {
                url: '/api/ref-contract-category/:id',
                method: 'DELETE',
            },
            updateRefContractCategory: {
                url: '/api/ref-contract-category/:id',
                method: 'PUT',
            },
            updateRefContractCategoryMailConf: {
                url: '/api/ref-contract-category/:id/email-config',
                method: 'PUT',
            },
            updateContractInfos: {
                url: '/api/contracts/:id_contract/update-info',
                method: 'POST',
            },
            updateContractElecBillingInfos: {
                url: '/api/contracts-elec/:id_contract/update-billing-info',
                method: 'PUT',
            },
            deleteDraft: {
                url: '/api/contractdrafts/:id',
                method: 'DELETE',
            },
            reimburseDeposit: {
                url: '/api/contracts/:id_contract/reimburse-deposit',
                method: 'POST',
            },
            refundCbDeposit: {
                url: '/api/security-deposit/:id/refund',
                method: 'POST',
            },
            mandateRevokation: {
                url: '/api/accounts/:id_account/mandate-revoke/:value',
                method: 'PUT',
            },
            getAdditionalContacts: {
                url: '/api/additional-contacts',
                method: 'GET',
                isArray: true,
            },
            addAdditionalContact: {
                url: '/api/contracts/:id_contract/additional-contacts',
                method: 'POST',
            },
            addAdditionalContactOnAccount: {
                url: '/api/accounts/:id_account/additional-contacts',
                method: 'POST',
            },
            updateAdditionalContact: {
                url: '/api/additional-contacts/:id',
                method: 'PUT',
            },
            staggerPayment: {
                url: '/api/payments/:id_payment/stagger',
                method: 'POST',
            },
            getModality: {
                url: '/api/ref-billing-modality/:id',
                method: 'GET',
            },
            addModality: {
                url: '/api/ref-billing-modality',
                method: 'POST',
            },
            updateModality: {
                url: '/api/ref-billing-modality/:id',
                method: 'PUT',
            },
            delModality: {
                url: '/api/ref-billing-modality/:id',
                method: 'DELETE',
            },
            cancelInvoiceV2: {
                url: '/api/invoices-v2/:id_invoice',
                method: 'DELETE',
            },
            setInvoiceV2Valuated: {
                url: '/api/invoices-v2/:id_invoice/valuated',
                method: 'POST',
            },
            setInvoiceOnHold: {
                url: '/api/invoices-v2/:id_invoice/onHold',
                method: 'POST',
            },
            setInvoiceV2Done: {
                url: '/api/invoices-v2/:id_invoice/done',
                method: 'POST',
            },
            setInvoiceV2Processing: {
                url: '/api/invoices-v2/:id_invoice/processing',
                method: 'POST',
            },
            updateParsGens: {
                url: '/api/parsing-generations/',
                method: 'PUT',
                isArray: true,
            },
            modifyDraftOffer: {
                url: '/api/contractdrafts/:id_contract/offer',
                method: 'PUT',
            },
            correctReadings: {
                url: '/api/readings/correction',
                method: 'POST',
            },
            cloneReading: {
                url: '/api/readings/correction/:id',
                method: 'PUT',
            },
            cloneGasReading: {
                url: '/api/readings-gas/correction/:id',
                method: 'PUT',
            },
            revertReadingCorrection: {
                url: '/api/readings/correction/:id',
                method: 'DELETE',
            },
            revertGasReadingCorrection: {
                url: '/api/readings-gas/correction/:id',
                method: 'DELETE',
            },
            updateReading: {
                url: '/api/readings/:id',
                method: 'PUT',
            },
            updateGasReading: {
                url: '/api/readings-gas/:id',
                method: 'PUT',
            },
            updateReadingBatch: {
                url: '/api/readings',
                method: 'PUT',
                isArray: true,
            },
            updateGasReadingBatch: {
                url: '/api/readings-gas',
                method: 'PUT',
                isArray: true,
            },
            updateCase: {
                url: '/api/cases/:id',
                method: 'PUT',
            },
            getNominationsFormatted: {
                url: '/api/nom-results-formatted/:id/formatted',
                method: 'GET',
            },
            deleteNomination: {
                url: '/api/nom-results/:id',
                method: 'DELETE',
            },
            myAccounts: {
                url: '/api/my-accounts',
                method: 'GET',
                isArray: true,
            },
            myOrganizations: {
                url: '/api/my-organizations?full=true',
                method: 'GET',
                isArray: true,
            },
            myAccount: {
                url: '/api/my-account/:id',
                method: 'GET',
            },
            updateMyAccount: {
                url: '/api/my-account/:id',
                method: 'PUT',
            },
            buildOpportunityFile: {
                url: '/api/admin/batch/overdue-phoning-campaign/build',
                method: 'POST',
            },
            transferContractOnAccount: {
                url: '/api/contract-transfer/:id_contract/to/:id_account',
                method: 'POST',
            },
            explainBalance: {
                url: '/api/contract-balance/:id_contract/explanation',
                method: 'GET',
                isArray: true,
            },
            cancelMetaInvoice: {
                url: '/api/meta-invoices/:id_invoice',
                method: 'DELETE',
            },
            internalizeOverdueRecovery: {
                url: '/api/overdue-recovery-campaign/:id_contract/internalize',
                method: 'GET',
            },
            getMetaPrepResult: {
                url: '/api/meta-invoices/:id/preparation-result',
                method: 'GET',
            },
            launchTaxDeclaration: {
                url: '/api/tax-declaration/launch',
                method: 'GET',
            },
            updateTaxStatus: {
                url: '/api/tax-declaration/update-status',
                method: 'GET',
            },
            toggleProcessedMeta: {
                url: '/api/meta-invoices/:id/toggle-processed',
                method: 'PUT',
            },
            fetchEnergyCheckHistory: {
                url: '/api/account/:id_account/energy-check-payments',
                method: 'GET',
                isArray: true,
            },
            massUpdateCategoryContacts: {
                url: '/api/categories-contacts',
                method: 'PUT',
                isArray: true,
            },
            massEditCategory: {
                url: '/api/categories/mass-edit',
                method: 'PUT',
            },
            availableMetaPeriods: {
                url: '/api/meta-invoices-available-billing-periods-for',
                method: 'GET',
            },
            generateSyncData: {
                url: '/api/tax-declaration/generateSyncData/:id_declaration',
                method: 'POST',
            },
            reconcileB2gPayments: {
                url: '/api/b2g-payments/:siret/reconcile',
                method: 'POST',
            },
            updateB2gPayment: {
                url: '/api/b2g-payments/:id',
                method: 'PUT',
            },
            updateB2gPaymentInvoiceNumber: {
                url: '/api/b2g-payments/:id/invoice_number/:invoice_number',
                method: 'PUT',
            },
            massUpdateB2gPayment: {
                url: '/api/b2g-payments',
                method: 'PUT',
                isArray: true,
            },
            getDataModelDefinition: {
                url: '/api/data-model-definitions/:modelName',
                method: 'GET',
                isArray: true,
            },
            refreshMatView: {
                url: '/api/db/refresh-mat-view/:matView',
                method: 'POST',
            },
            getContractHistory: {
                url: '/api/contracts/:id_contract/history',
                method: 'GET',
            },
            modifyInvoiceComChannel: {
                url: '/api/accounts/:id_account/billing-acc/invoice-com-channel',
                method: 'PUT',
            },
            migrateValidationPerimeterToAccount: {
                url: '/api/validation-perimeters/:id/migrate-to/:id_managed_account',
                method: 'PUT',
            },
            showCategoryIban: {
                url: `/api/category-iban/:id/show-iban`,
                method: 'GET',
            },
            showCategoryHistoIban: {
                url: `/api/category-iban-history/:id/show-iban`,
                method: 'GET',
            },
            changeSiretIbanStatus: {
                url: `/api/category-iban/:id`,
                method: 'PUT',
            },
            createManagedAccount: {
                url: `/api/managed-account`,
                method: 'POST',
            },
            createTinyUrl: {
                url: `/api/tiny-urls`,
                method: 'POST',
            },
            deleteTinyUrl: {
                url: `/api/tiny-urls/:id`,
                method: 'DELETE',
            },
            modifyTinyUrl: {
                url: `/api/tiny-urls/:id`,
                method: 'PUT',
            },
            updateProDraft: {
                url: '/api/pro-draft/:id',
                method: 'PUT',
            },
            addAgreement: {
                url: '/api/agreements',
                method: 'POST',
            },
            updateAgreement: {
                url: '/api/agreements/:id',
                method: 'PUT',
            },
            checkSponsorOnDraft: {
                url: '/api/contractdrafts/:id_draft/check-sponsor/:sponsor_id',
                method: 'GET',
            },
            removeSponsorOnDraft: {
                url: '/api/contractdrafts/:id_draft/sponsor',
                method: 'DELETE',
            },
            getAgreementsForOrg: {
                url: '/api/organization/:organization/agreements',
                method: 'GET',
                isArray: true,
            },
            getAgreementForCategory: {
                url: '/api/category/:id/agreement-elec',
                method: 'GET',
            },
            getLandscapeDone: {
                url: '/api/landscape/:id_contract/done',
                method: 'GET',
            },
            updateAgreementConsents: {
                url: '/api/agreements/:id/consents',
                method: 'POST',
            },
            closeAgreement: {
                url: '/api/agreements/:id/close',
                method: 'PUT',
            },
            getContractConsents: {
                url: '/api/contracts/:id_contract/consents',
                method: 'GET',
                isArray: true,
            },
            updateConsents: {
                url: '/api/accounts/:id_account/contracts/:id_contract/consents',
                method: 'POST',
                isArray: true,
            },
            getPrmById: {
                url: '/api/prms/:id_prm',
                method: 'GET',
            },
            multiSearch: {
                url: '/api/multi-search',
                method: 'POST',
                isArray: true,
            },
            cancelCreditTransactionInvestment: {
                url: '/api/admin/credit-transactions/:id/cancel-investment',
                method: 'DELETE',
            },
            getCsrAvailableAssignees: {
                url: '/api/csr-available-assignees',
                method: 'GET',
                isArray: true,
            },
            updateManagedAccountDefaultProvOffer: {
                url: '/api/managed-accounts/:id/default-provider-offers',
                method: 'PUT',
            },
            getContractElecEnedisServices: {
                url: '/api/contracts-elec/:id_contract/enedis-services',
                method: 'GET',
                isArray: true,
            },
            searchBatchProcesses: {
                url: '/api/batch-processes/search',
                method: 'GET',
                isArray: true,
            },
            refreshBatchProcessProgress: {
                url: '/api/batch-processes/:id/updated-progress',
                method: 'GET',
            },
            getContractAvailableProviderOffers: {
                url: '/api/contracts/:id_contract/provider-offer-list',
                method: 'GET',
                isArray: true,
            },
            myOptimizableAccounts: {
                url: '/api/my-optimizable-accounts',
                method: 'GET',
                isArray: true,
            },
            myOptimizableAccount: {
                url: '/api/my-optimizable-account/:id',
                method: 'GET',
            },
            myEcosessionAccounts: {
                url: '/api/my-ecosession-accounts',
                method: 'GET',
                isArray: true,
            },
            mockOptimizationForOrg: {
                url: '/api/organizations/:organization/mock-optimization/:type',
                method: 'POST',
                isArray: true,
            },
            recycleTemporaryConnection: {
                url: '/api/temporary-connection/:id/recycle',
                method: 'PUT',
            },
            fetchIrrecoverabilityDeclarationPayments: {
                url: '/api/irrecoverability-declarations/:id/payments',
                method: 'GET',
                isArray: true,
            },
            unlinkPaymentFromDeclaration: {
                url: '/api/irrecoverability-declarations/:id_declaration/payment/:id_payment',
                method: 'DELETE',
            },
            linkPaymentFromDeclaration: {
                url: '/api/irrecoverability-declarations/:id_declaration/payment/:id_payment',
                method: 'PUT',
            },
            addPrescribedAmountOnCirPayment: {
                url: '/api/irrecoverability-payment/:id_payment/prescribed-amount',
                method: 'PUT',
            },
            updateSendInBlueSubscriptionList: {
                url: '/api/ref-sendinblue-lists/:id',
                method: 'PUT',
            },
            fetchSendInBlueSubscriptionListStats: {
                url: '/api/ref-sendinblue-lists/:id/stats',
                method: 'GET',
            },
            fetchSendInBlueSubscriptionLists: {
                url: '/api/ref-sendinblue-lists/search',
                method: 'GET',
                isArray: true,
                headers: {'x-order-by': 'functional_id'},
            },
            fetchAccountSubscriptions: {
                url: '/api/accounts/:id_account/subscriptions',
                method: 'GET',
                isArray: true,
            },
            modifyAccountSubscriptions: {
                url: '/api/accounts/:id_account/subscriptions',
                method: 'PUT',
            },
            createRefConsent: {
                url: '/api/ref-data-consents',
                method: 'POST',
            },
            updateRefConsent: {
                url: '/api/ref-data-consents/:id',
                method: 'PUT',
            },
            getDraftConsents: {
                url: '/api/drafts/:id_draft_basic/consents',
                method: 'GET',
                isArray: true,
            },
            updateDraftConsents: {
                url: '/api/drafts/:id_draft_basic/consents',
                method: 'PUT',
            },
            getDraftSubscriptions: {
                url: '/api/drafts/:id_draft_basic/subscriptions',
                method: 'GET',
                isArray: true,
            },
            updateDraftSubscriptions: {
                url: '/api/drafts/:id_draft_basic/subscriptions',
                method: 'PUT',
            },
            updateIrrecoverabilityDeclaration: {
                url: '/api/irrecoverability-declarations/:id',
                method: 'PUT',
            },
            updateSiret: {
                url: '/api/sirets/:id',
                method: 'PUT',
            },
            updateSiretStatus: {
                url: '/api/sirets/:id/status/:status',
                method: 'PUT',
            },
            fetchTechnicalContactsForAccount: {
                url: '/api/accounts/:id_account/additional-contacts/TECHNICAL',
                method: 'GET',
                isArray: true,
            },
            massUpdateAdditionalContacts: {
                url: '/api/additional-contacts-mass-update',
                method: 'PUT',
            },
            multiPotInvestment: {
                url: '/api/accounts/:id_account/pot-multi-investment',
                method: 'POST',
            },
            modifyContractDate: {
                url: '/api/contracts/:id_contract/contract-dates',
                method: 'PUT',
            },
            createCompensationMeta: {
                url: '/api/meta-invoices/compensation',
                method: 'POST',
            },
        },
    ),
).factory('OGC', ($resource) =>
    $resource(
        'all', {}, {
            resolveContactList: {
                url: '/api/ogc/resolve-contact-list',
                method: 'POST',
                isArray: true,
            },
            resolveContactListCount: {
                url: '/api/ogc/resolve-contact-list/count',
                method: 'POST',
            },
            countContactList: {
                url: '/api/ogc-contact-lists/:id/contacts-count',
                method: 'GET',
            },
            addContactList: {
                url: '/api/ogc-contact-lists',
                method: 'POST',
            },
            updateContactList: {
                url: '/api/ogc-contact-lists/:id',
                method: 'PUT',
            },
            addCampaign: {
                url: '/api/ogc-campaigns',
                method: 'POST',
            },
            updateCampaign: {
                url: '/api/ogc-campaigns/:id',
                method: 'PUT',
            },
            deleteCampaign: {
                url: '/api/ogc-campaigns/:id',
                method: 'DELETE',
            },
            fetchExternalCampaigns: {
                url: '/api-admin/ogc-external/campaigns',
                method: 'GET',
                isArray: true,
            },
            getFolders: {
                url: '/api-admin/ogc-external/folders',
                method: 'GET',
                isArray: true,
            },
            createFolder: {
                url: '/api-admin/ogc-external/folders',
                method: 'POST',
            },
            synchronizeList: {
                url: '/api-admin/ogc-external/synchronize-contact-list/:id',
                method: 'POST',
            },
            deleteContactList: {
                url: '/api-admin/ogc-external/contact-list/:id',
                method: 'DELETE',
            },
            checkSync: {
                url: '/api-admin/ogc-external/cron-synch',
                method: 'POST',
            },
        },
    ),
).factory('DataAccessTags', ($resource) =>
    $resource(
        'tag', {}, {
            getTags: {
                url: '/api/ref-tag?withRelated=assignees',
                method: 'GET',
                isArray: true,
            },
            addTag: {
                url: '/api/ref-tag',
                method: 'POST',
            },
            deleteTag: {
                url: '/api/ref-tag/:id',
                method: 'DELETE',
            },
            updateTag: {
                url: '/api/ref-tag/:id',
                method: 'PUT',
            },
            addAccountTag: {
                url: '/api/account-tag',
                method: 'POST',
            },
            delAccountTag: {
                url: '/api/account-tag/:id_tag',
                method: 'DELETE',
            },
            allTags: {
                url: '/api/account-tag?withRelated=account,tag',
                method: 'GET',
                isArray: true,
            },
            accountTags: {
                url: '/api/accounts/:id_account/tags',
                method: 'GET',
                isArray: true,
            },
            getRefContractTags: {
                url: '/api/ref-contract-tags',
                method: 'GET',
                isArray: true,
            },
            addRefContractTag: {
                url: '/api/ref-contract-tags',
                method: 'POST',
            },
            deleteRefContractTag: {
                url: '/api/ref-contract-tags/:id',
                method: 'DELETE',
            },
            updateRefContractTag: {
                url: '/api/ref-contract-tags/:id',
                method: 'PUT',
            },
            addContractTag: {
                url: '/api/contract-tags',
                method: 'POST',
            },
            delContractTag: {
                url: '/api/contract-tags/:id',
                method: 'DELETE',
            },
            contractTags: {
                url: '/api/contracts/:id_contract/tags',
                method: 'GET',
                isArray: true,
            },
        },
    ),
).factory('DataAccessTimetableModifs', ($resource) =>
    $resource(
        'modifs', {}, {
            get: {
                url: '/api/contracts/:id_contract/timetable/modifs',
                method: 'GET',
                isArray: true,
            },
            set: {
                url: '/api/contracts/:id_contract/timetable/modifs',
                method: 'POST',
                isArray: true,
            },
        },
    ),
).factory('DataAccessReferences', ($resource) =>
    $resource(
        'all', {}, {
            ref: {
                url: '/api/references/:id',
                method: 'GET',
            },
            refArray: {
                url: '/api/references/:id',
                method: 'GET',
                isArray: true,
            },
            searchRefTable: {
                method: 'GET',
                url: '/api/ref-table/:idTable/search',
                isArray: true,
            },
        },
    ),
).factory('ApiUser', ($resource) =>
    $resource(
        'all', {}, {
            login: {
                url: '/authenticate',
                method: 'POST',
                transformResponse(data, headers) {
                    const response = {}
                    _.assignIn(response, JSON.parse(data))
                    response.headers = headers()
                    return response
                },
            },
            selfReport: {
                url: '/api-user/admin/contracts/:id_contract/self-report',
                method: 'POST',
            },
            selfReportB2G: {
                url: '/api-user/admin/b2g-contracts/:id_contract/self-report',
                method: 'POST',
            },
            resetPassword: {
                url: '/api-user/anon/forgot-passwd',
                method: 'POST',
            },
            fetchPRM: {
                url: '/api-user/enedis-prm/:id_prm',
                method: 'GET',
            },
            fetchPRMDetails: {
                url: '/api-user/enedis-prm-details/:id_prm?v=4',
                method: 'GET',
            },
            fetchPrmDetailsForContract: {
                url: '/api-user/contract/:idContract/enedis-prm-details?v=4',
                method: 'GET',
            },
            eligibilityPRM: {
                url: '/api-user/eligibility/prm/:id_prm?id_contract=:id_contract&consent=true',
                method: 'GET',
            },
            eligibilityGeo: {
                url: '/api-user/eligibility/inseecode/:id',
                method: 'GET',
            },
            annualCons: {
                url: '/api-user/annual-cons/:id_prm',
                method: 'GET',
            },
            rawCons: {
                url: '/api-user/raw-cons-measure/:id_prm',
                method: 'GET',
            },
            rawConsForContract: {
                url: '/api-user/contract/:idContract/raw-cons-measure',
                method: 'GET',
            },
            draftEstimatedV1: {
                url: '/api-user/contractdraft/:idContract/estimated?return=generator,annual,monthly,timePeriod',
                method: 'POST',
            },
            draftEstimatedV2: {
                url: '/api-user/contractdraft/:idContract/estimated/simu?return=generator,annual,monthly,timePeriod&format=old',
                method: 'POST',
            },
            amendmentEstimation: {
                url: '/api-user/contract/:idContract/timetable/amendment',
                method: 'POST',
            },
            getLandscapeAnswers: {
                url: '/api-user/landscape/:id_contract/questions',
                method: 'GET',
                isArray: true,
            },
            checkLandscapeRequired: {
                url: '/api-user/landscape/:idContract/required',
                method: 'GET',
            },
            searchLandscape: {
                url: '/api-user/landscape/:idContract/search',
                method: 'GET',
            },
            postFullLandscape: {
                url: '/api-user/landscape/:idContract/full',
                method: 'POST',
            },
            correctAccount: {
                url: '/api-user/admin/account/:id/correction',
                method: 'PUT',
            },
            logout: {
                url: '/api-user/logout',
                method: 'POST',
            },
            checkLogin: {
                url: '/api-user/check-login',
                method: 'GET',
            },
            adminSendMail: {
                url: '/api-user/admin/account/:id_account/send-email',
                method: 'POST',
            },
            adminSendTemplatedSms: {
                url: '/api-user/admin/accounts/:id_account/send-templated-sms',
                method: 'POST',
            },
            newUser: {
                url: '/api-user/admin/signup-bo',
                method: 'POST',
            },
            newEndUser: {
                url: '/api-user/anon/signup',
                method: 'POST',
            },
            changeDraftOwner: {
                url: '/api-user/admin/contractdrafts/:idDraft/chown/:idAccount',
                method: 'POST',
            },
            generateMandate: {
                url: '/api-user/admin/generate-mandate/:idDraft',
                method: 'GET',
            },
            billShock: {
                url: '/api-user/contracts/:id_contract/estimate-regulation',
                method: 'GET',
            },
            activateAccount: {
                url: '/api-user/admin/account/:id_account/activate',
                method: 'POST',
            },
            deactivateAccount: {
                url: '/api-user/admin/account/:id_account/deactivate',
                method: 'POST',
            },
            freezeAccount: {
                url: '/api-user/admin/billingaccount/:id/freeze',
                method: 'POST',
            },
            thawAccount: {
                url: '/api-user/admin/billingaccount/:id/thaw',
                method: 'POST',
            },
            checkPromo: {
                url: '/api-user/admin/account/:id_account/promo/:promo/check?',
            },
            validateOverdueCheck: {
                url: '/api-user/admin/account/:idAccount/contract/:idContract/validate',
                method: 'POST',
            },
            cancelContract: {
                url: '/api-user/admin/account/:idAccount/contract/:idContract/cancel',
                method: 'POST',
            },
            retractContract: {
                url: '/api-user/admin/account/:idAccount/contract/:idContract/retract',
                method: 'POST',
            },
            terminateContract: {
                url: '/api-user/admin/account/:idAccount/contract/:idContract/terminate',
                method: 'POST',
            },
            askContractTermination: {
                url: '/api-user/admin/account/:idAccount/contract/:idContract/ask-termination',
                method: 'POST',
            },
            suspendContract: {
                url: '/api-user/admin/contracts/:idContract/suspend-power',
                method: 'POST',
            },
            massSuspendContract: {
                url: '/api-user/admin/batch/contracts/suspend-power',
                method: 'POST',
            },
            reduceContract: {
                url: '/api-user/admin/contracts/:idContract/reduce-power',
                method: 'POST',
            },
            massReduceContract: {
                url: '/api-user/admin/batch/contracts/reduce-power',
                method: 'POST',
            },
            reactivateContract: {
                url: '/api-user/admin/contracts/:idContract/reactivate-power',
                method: 'POST',
            },
            restoreContract: {
                url: '/api-user/admin/contracts/:idContract/restore-power',
                method: 'POST',
            },
            markOverdue: {
                url: '/api-user/contracts/:idContract/mark-overdue',
                method: 'POST',
            },
            unmarkOverdue: {
                url: '/api-user/contracts/:idContract/unmark-overdue',
                method: 'POST',
            },
            refreshOverdue: {
                url: '/api-user/contracts/:idContract/overdue-scoring?refresh=:refresh',
                method: 'GET',
            },
            refreshDraftOverdue: {
                url: '/api-user/contractdrafts/:idDraft/overdue-scoring',
                method: 'GET',
            },
            lookupAddr: {
                url: '/api-user/selfcare/lookup-addr?q=:q&strict=false',
                method: 'GET',
                isArray: true,
            },
            lookupStrictAddr: {
                url: '/api-user/selfcare/lookup-addr?q=:q',
                method: 'GET',
                isArray: true,
            },
            lookupPrm: {
                url: '/api-user/prm-search',
                method: 'POST',
                isArray: true,
            },
            changePhone: {
                url: '/api-user/admin/account/:idAccount/phone-modif',
                method: 'POST',
            },
            changeEmail: {
                url: '/api-user/admin/account/:idAccount/email-modif',
                method: 'POST',
            },
            activateContract: {
                url: '/api-user/admin/account/:idAccount/contract/:idContract/activate',
                method: 'POST',
            },
            notifyActivationError: {
                url: '/api-user/admin/account/:idAccount/contract/:idContract/notify-activation-error',
                method: 'POST',
            },
            reportContractActivation: {
                url: '/api-user/admin/contract/:idContract/report-sge-activation',
                method: 'POST',
            },
            updateAccount: {
                url: '/api-user/admin/account/:id_account',
                method: 'PUT',
            },
            updateBillingAddr: {
                url: '/api-user/admin/account/:id_account/addr-modif',
                method: 'POST',
            },
            openTicket: {
                url: '/api-user/admin/contact',
                method: 'POST',
            },
            retryPayment: {
                url: '/api-user/admin/account/:id_account/payment/:id_payment/retry?force=:force',
                method: 'POST',
            },
            fetchPaymentBankStatus: {
                url: '/api-user/payments/refresh-status?scheme=:scheme',
                method: 'POST',
            },
            refundCBPayment: {
                url: '/api-user/payments/:id/refund',
                method: 'POST',
            },
            computeTariff: {
                url: '/api-user/enedis-prestations/computation',
                method: 'POST',
            },
            listTickets: {
                url: '/api-user/admin/account/:idAccount/contacts',
                method: 'GET',
                isArray: true,
            },
            creditCardRedirect: {
                url: '/api-user/admin/account/:id_account/payment/:id_payment/credit-card-redirect',
                method: 'GET',
            },
            modifyIban: {
                url: '/api-user/admin/account/:id_account/mandate',
                method: 'PUT',
            },
            signNewMandate: {
                url: '/api-user/admin/accounts/:id_account/sign-mandate',
                method: 'POST',
            },
            createAlias: {
                url: '/api-user/admin/accounts/:id_account/create-alias',
                method: 'POST',
            },
            changePwd: {
                url: '/api-user/anon/passwd-backoffice/:id',
                method: 'POST',
            },
            getChangePwdEmail: {
                url: '/api-user/anon/passwd/:token',
                method: 'GET',
            },
            sendSms: {
                url: '/api-user/admin/accounts/:id_account/send-sms',
                method: 'POST',
            },
            startOverdue: {
                url: '/api-user/errors/overdue',
                method: 'POST',
            },
            startTerminatedOverdue: {
                url: '/api-user/errors/terminated-overdue',
                method: 'POST',
            },
            cancelOverdue: {
                url: '/api-user/overdue-processes/:id',
                method: 'DELETE',
            },
            killOverdueProcess: {
                url: '/api-user/kill-overdue-processes/:id',
                method: 'DELETE',
            },
            delayOverdue: {
                url: '/api-user/overdue-processes/:id/delay',
                method: 'PUT',
            },
            bankAccount: {
                url: '/api-user/account/:id_account/mandate-info',
                method: 'GET',
            },
            broadcast: {
                url: '/api-user/ws-replicator/event',
                method: 'POST',
            },
            refreshPrm: {
                url: '/api-user/contract/:idContract/prm/:idPrm',
                method: 'PUT',
            },
            sendProofOfResidence: {
                url: '/api-user/admin/account/:idAccount/documents/:idContract/proofofresidence?mail=true',
                method: 'GET',
            },
            getEnedisContact: {
                url: '/api-user/contracts/:id_contract/enedis-contact',
                method: 'GET',
            },
            blockForOverdue: {
                url: '/api-user/contracts/:id_contract/block-overdue',
                method: 'POST',
            },
            transformDraft: {
                url: '/api-user/contractdrafts/:id_draft/transform',
                method: 'POST',
            },
            massActivate: {
                url: '/api-user/admin/batch/contracts/activate',
                method: 'POST',
            },
            massTerminate: {
                url: '/api-user/admin/batch/contracts/terminate',
                method: 'POST',
            },
            syncSlimpay: {
                url: '/api-user/payments/process-errors',
                method: 'POST',
            },
            cancelCase: {
                url: '/api-user/case/:idCase/cancel',
                method: 'POST',
            },
            refreshCase: {
                url: '/api-user/case/:idCase/refresh',
                method: 'POST',
            },
            addCase: {
                url: '/api-user/case/:idCase/add',
                method: 'POST',
            },
            computeBillingModality: {
                url: '/api-user/admin/contracts/:id_contract/billing-modality',
                method: 'GET',
            },
            adminSendTerminationEmail: {
                url: '/api-user/admin/account/:id_account/contract/:id_contract/termination-email',
                method: 'POST',
            },
            checkReadings: {
                url: '/api-user/prm/:id_prm/check-report',
                method: 'POST',
            },
            potExplaination: {
                url: '/api-user/accounts/:id_account/explain-pot',
                method: 'GET',
            },
            anonPaymentLink: {
                url: '/api-user/admin/contract/:id_contract/send-anon-payment-link',
                method: 'POST',
            },
            modifyContractOffer: {
                url: '/api-user/contracts/:id_contract/offer',
                method: 'PUT',
            },
            runNomination: {
                url: '/api-user/nomination/run',
                method: 'POST',
                isArray: true,
            },
            sendNomination: {
                url: '/api-user/nomination/:id/send',
                method: 'POST',
            },
            fetchForecasts: {
                url: '/api-user/rte/fetch-forecasts',
                method: 'GET',
            },
            bypassRetract: {
                method: 'POST',
                url: '/api-user/accounts/:idAccount/contract/:idContract/bypass_retraction',
            },
            validatePerimeter: {
                url: '/api-user/pdl-perimeter/:id_account/validation',
                method: 'POST',
            },
            sendPerimeterReminder: {
                url: '/api-user/pdl-perimeter/:id_account/reminder',
                method: 'POST',
            },
            adminSendCertificateEmail: {
                url: '/api-user/admin/account/:id_account/contract/:id_contract/certificate-email',
                method: 'POST',
            },
            updateUser: {
                url: '/api-user/admin/users/:id_account',
                method: 'PUT',
            },
            sendMetaInvoiceToChorus: {
                url: '/api-user/chorus/invoices/:id_meta_invoice/submit',
                method: 'POST',
            },
            metaInvoiceChorusedManually: {
                url: '/api-user/chorus/invoices/:id_meta_invoice/submitted-manually',
                method: 'POST',
            },
            checkChorusStatus: {
                url: '/api-user/chorus/invoices/:id_meta_invoice/status',
                method: 'GET',
            },
            massCheckChorusStatus: {
                url: '/api-user/chorus/batch-update-status',
                method: 'POST',
            },
            initDraft: {
                url: '/api-user/init-contract-draft/:idAccount',
                method: 'GET',
            },
            preshootUserDraft: {
                url: '/api-user/preshoot-contract-draft/:idAccount',
                method: 'PUT',
            },
            generateTaxDocuments: {
                url: '/api-user/admin/tax-declaration/document',
                method: 'POST',
                isArray: true,
            },
            sendTaxDeclarationMail: {
                url: '/api-user/admin/tax-declaration/send-email',
                method: 'POST',
                isArray: true,
            },
            getAdministrableContent: {
                url: '/api-user/content/:contentId',
                method: 'GET',
            },
            sendPenaltyReminder: {
                url: '/api-user/b2g-accounts/:id_account/penalty-reminder-email',
                method: 'POST',
            },
            massModifyEnergyType: {
                url: '/api-user/validation-clusters/energy_type',
                method: 'PUT',
            },
            validatePerimeterAsIs: {
                url: '/api-user/pdl-perimeter/:id_account/validation-as-is',
                method: 'POST',
            },
            bulkPurchaseCheckout: {
                url: '/api-user/bulk-purchase-draft/:id_draft/check-out',
                method: 'POST',
            },
            batchBulkPurchaseContact: {
                url: '/api-user/batch/bulk-purchase/contact',
                method: 'POST',
            },
            createSiretIban: {
                url: '/api-user/siret/:siret/iban',
                method: 'POST',
            },
            updateBillingModality: {
                method: 'PUT',
                url: '/api-user/contracts/:idContract/billing-modality',
            },
            addRefContractCategory: {
                url: '/api-user/ref-contract-category',
                method: 'POST',
            },
            deleteCategoryIban: {
                url: '/api-user/category-iban/:id',
                method: 'DELETE',
            },
            amendContract: {
                url: '/api-user/admin/contract/:id_contract/amendment',
                method: 'POST',
            },
            refreshSuspensionStatus: {
                url: '/api-user/admin/contract/:idContract/refresh-suspension-status/:actualSuspensionStatus',
                method: 'POST',
            },
            sendServiceOrder: {
                url: '/api-user/service-orders/:id/send',
                method: 'POST',
            },
            consumptionAnalysis: {
                url: '/api-user/contracts/:id_contract/consumption-analysis',
                method: 'GET',
            },
            lookupPce: {
                url: '/api-user/grdf/search-pce?idCad=A180000007',
                method: 'POST',
            },
            sendCheckoutEmail: {
                url: '/api-user/drafts/:id_draft_basic/send-checkout-email',
                method: 'POST',
            },
            logCallComment: {
                url: '/api-user/contacts-phone/:id/comment',
                method: 'POST',
            },
            validatedModificationValues: {
                url: '/api-user/validate-draft-values',
                method: 'POST',
            },
            getContractInitialEstimator: {
                url: '/api-user/contracts/:id/initial-estimator',
                method: 'GET',
            },
            cdaAnalysis: {
                url: '/api-user/cda/contract/:idContract/analysis/:analysisType',
                method: 'POST',
            },
            refreshContractElecEnedisServices: {
                url: '/api-user/contracts-elec/:id_contract/enedis-services',
                method: 'GET',
                isArray: true,
            },
            oppositionCurvesRecording: {
                url: '/api-user/data-collect/:id_contract/opposition',
                method: 'POST',
            },
            getLoadCurves: {
                url: '/api-user/data-collect/contract/:idContract/dc-loadcurve',
                method: 'GET',
                isArray: true,
            },
            getIndexes: {
                url: '/api-user/data-collect/contract/:idContract/dc-index',
                method: 'GET',
                isArray: true,
            },
            getPowerMaxHistory: {
                method: 'GET',
                url: '/api-user/data-collect/:idContract/pmax-history',
                isArray: true,
            },
            getConso: {
                url: '/api-user/data-collect/contract/:idContract/dc-cons',
                method: 'GET',
                isArray: true,
            },
            synchronizeContractElecEnedisServices: {
                url: '/api-user/contracts-elec/:id_contract/sync-services-with-enedis',
                method: 'POST',
            },
            transformValidationPerimeter: {
                url: '/api-user/validation-perimeter/transformation',
                method: 'POST',
            },
            validateOptimization: {
                url: '/api-user/optimization-validation/:id_account/validation',
                method: 'POST',
            },
            validateEcosession: {
                url: '/api-user/ecosession/:id_account/validation',
                method: 'POST',
            },
            validateOptimizationAsIs: {
                url: '/api-user/optimization-validation/:id_account/validation-as-is/:status',
                method: 'POST',
            },
            validateEcosessionAsIs: {
                url: '/api-user/ecosession/:id_account/validation-as-is/:status',
                method: 'POST'
            },
            createManagementSheet: {
                url: '/api-user/management-sheets/:type',
                method: 'POST',
            },
            sendManagementSheet: {
                url: '/api-user/management-sheets/:id/send',
                method: 'POST',
            },
            regenerateManagementSheet: {
                url: '/api-user/management-sheets/:id/regen',
                method: 'POST',
            },
            sendOptiValidationReminder: {
                url: '/api-user/optimization-validation/:id_account/reminder?type=:type',
                method: 'POST',
            },
            createIrrecoverabilityDeclaration: {
                url: '/api-user/irrecoverability-declarations',
                method: 'POST',
            },
            regenIrrecoverabilityDeclaration: {
                url: '/api-user/irrecoverability-declarations/:id/regen',
                method: 'POST',
            },
            transferToSeniorAdvisor: {
                url: '/api-user/drafts/:id_draft_basic/transfer-to-senior-advisor',
                method: 'POST',
            },
            getLastWithoutPrmEstimation: {
                url: '/api-user/drafts/:id_draft_basic/last-without-prm-estimation',
                method: 'GET',
            },
            invoiceReversalDone: {
                url: '/api-user/meta-invoices-reversal/:id/done',
                method: 'PUT',
            },
            invoiceReversalMassDone: {
                url: '/api-user/meta-invoices-reversal/mass-done',
                method: 'PUT',
            },
            invoiceDone: {
                url: '/api-user/meta-invoices/:id/done',
                method: 'PUT',
            },
            invoiceMassDone: {
                url: '/api-user/meta-invoices/mass-done',
                method: 'PUT',
            },
            validateSiret: {
                url: '/api-user/siret/:siret',
                method: 'GET',
            },
            createOrUpdateSiret: {
                url: '/api-user/siret/:siret?source=ALL&store=true',
                method: 'GET',
            },
            createConsumptionDriftReport: {
                url: '/api-user/consumption-drift-reports/:type',
                method: 'POST',
            },
            sendConsumptionDriftReport: {
                url: '/api-user/consumption-drift-reports/:id/send',
                method: 'POST',
            },
            regenerateConsumptionDriftReport: {
                url: '/api-user/consumption-drift-reports/:id/regen',
                method: 'POST',
            },
            linkDiabolocomCallToBackofficeUser: {
                url: '/api-user/diabolocom-link-call',
                method: 'POST',
            },
            mockDiabolocomFakeCall: {
                url: '/api-user/test/fake-diabolocom-call',
                method: 'POST',
            },
            scoreDraftInterest: {
                url: '/api-user/drafts-elec/:idDraftElec/interest-scoring',
                method: 'GET',
            },
            completePotBalance: {
                url: '/api-user/accounts/:id_account/pot-balance',
                method: 'GET',
            },
            retrieveMeasure: {
                url: '/api-user/data-collect/:id_contract/measure',
                method: 'GET',
            },
            processKrakenMigration: {
                url: '/api-user/kraken-migration/accounts/:id_account/migrate/:step',
                method: 'POST',
            },
            requestM023: {
                url: '/api-user/m023/request',
                method: 'POST',
                isArray: true,
            },
        },
    ),
).factory('ApiCons', ($resource) =>
    $resource(
        'all', {}, {
            estimatedV2: {
                method: 'GET',
                url: '/api-cons/estimated/v2/:idContract',
            },
            monthlyV2: {
                url: '/api-cons/estimated-cons/v2/:idContract',
                method: 'GET',
            },
            // dailyV1: {
            //     url: '/api-cons/estimated-daily/:estimated_id',
            //     method: 'GET',
            // },
            dailyV2: {
                url: '/api-cons/estimated-daily/v2/:idContract',
                method: 'GET',
            },
            // metadataV1: {
            //     url: '/api-cons/estimated/:estimated_id/metadata',
            //     method: 'GET',
            // },
            metadataV2: {
                url: '/api-cons/estimated/v2/:idContract/metadata',
                method: 'GET',
            },
            dcLoadCurve: {
                method: 'GET',
                url: '/api-cons/dc-loadcurve/:idContract',
                isArray: true,
            },
            dcIndex: {
                method: 'GET',
                url: '/api-cons/dc-index/:idContract',
                isArray: true,
            },
            dcPower: {
                method: 'GET',
                url: '/api-cons/dc-power/:idContract',
                isArray: true,
            },
            dcPowerMax: {
                method: 'GET',
                url: '/api-cons/dc-power/:idContract/max?subset=start,end',
            },
            dcCons: {
                method: 'GET',
                url: '/api-cons/dc-cons/:idContract',
                isArray: true,
            },
            getFirstDeclaredCons: {
                method: 'GET',
                url: '/api-cons/declared-cons/:id_contract/first',
            },
            getLastDeclaredCons: {
                method: 'GET',
                url: '/api-cons/declared-cons/:id_contract/last',
            },
            searchCDA: {
                method: 'GET',
                url: '/api-cons/crud-cda/search',
                isArray: true,
                headers: {
                    'x-columns': 'timePeriod;analysis.result',
                },
            },
        },
    ),
).factory('ApiContent', ($resource) =>
    $resource(
        'all', {}, {
            getToken: {
                method: 'POST',
                url: '/api-content/tokens?ttl=1&unit=M',
            },
            updateClientContactPhone: {
                method: 'PUT',
                url: '/api-content/client-contacts-phone/:id',
            },
        },
    ),
).factory('XmlParser', ($resource) =>
    $resource(
        'all', {}, {
            generation: {
                url: '/parser/generation',
                method: 'POST',
            },
            parsing: {
                url: '/parser/parsing',
                method: 'POST',
            },
        },
    ),
).factory('Nodebb', ($resource) =>
    $resource(
        'all', {}, {
            user: {
                url: '/communaute/api/user/uid/:id',
                method: 'GET',
            },
        },
    ),
).factory('DataAccessFeatures', ($resource) =>
    $resource(
        'feature', {}, {
            getFeatures: {
                url: '/api/features',
                method: 'GET',
                isArray: true,
            },
            getFeature: {
                url: '/api/features/:id',
                method: 'GET',
            },
            postFeature: {
                url: '/api/features',
                method: 'POST',
            },
            putFeature: {
                url: '/api/features/:id',
                method: 'PUT',
            },
            delFeature: {
                url: '/api/features/:id',
                method: 'DELETE',
            },
        },
    ),
).factory('DataAccessOffers', ($resource) =>
    $resource(
        'offer', {}, {
            getOffers: {
                url: '/api/ref-provider-offers',
                method: 'GET',
                isArray: true,
            },
            getSelectableOffers: {
                url: '/api/ref-provider-offers/selectable-offers',
                method: 'GET',
            },
            addOffer: {
                url: '/api/ref-provider-offers',
                method: 'POST',
            },
            updateOffer: {
                url: '/api/ref-provider-offers/:id',
                method: 'PUT',
            },
            delOffer: {
                url: '/api/ref-provider-offers/:id',
                method: 'DELETE',
            },
            getHgzOffers: {
                url: '/api/ref-hgz-offers?withRelated=cons',
                method: 'GET',
                isArray: true,
            },
            addHgzOffer: {
                url: '/api/ref-hgz-offers',
                method: 'POST',
            },
            updateHgzOffer: {
                url: '/api/ref-hgz-offers/:id',
                method: 'PUT',
            },
            delHgzOffer: {
                url: '/api/ref-hgz-offers/:id',
                method: 'DELETE',
            },
            addHgzOfferCons: {
                url: '/api/ref-hgz-offer-cons',
                method: 'POST',
                isArray: true,
            },
            updateHgzOfferCons: {
                url: '/api/ref-hgz-offer-cons/:id',
                method: 'PUT',
            },
        },
    ),
).factory('ProviderOffersApi', ($resource) =>
    $resource(
        'offer', {}, {
            getProviderOfferVersions: {
                url: '/api/ref-provider-offers-v2/:id/versions',
                method: 'GET',
                isArray: true,
            },
            getProviderOfferAtDate: {
                url: '/api/ref-provider-offers-v2/:id/full',
                method: 'GET',
            },
            updateProviderOffer: {
                url: '/api/ref-provider-offers-v2/:id',
                method: 'PUT',
            },
            createProviderOffer: {
                url: '/api/ref-provider-offers-v2',
                method: 'POST',
            },
        },
    ),
).factory('DataAccessTrv', ($resource) =>
    $resource(
        'trv', {}, {
            getTrv: {
                url: '/api/ref-trv?withRelated=cons',
                method: 'GET',
                isArray: true,
                headers: {'x-order-by': 'from_date,plan_id'},
            },
            addTrv: {
                url: '/api/ref-trv',
                method: 'POST',
            },
            updateTrv: {
                url: '/api/ref-trv/:id',
                method: 'PUT',
            },
            delTrv: {
                url: '/api/ref-trv/:id',
                method: 'DELETE',
            },
            addTrvCons: {
                url: '/api/ref-trv-cons',
                method: 'POST',
                isArray: true,
            },
            updateTrvCons: {
                url: '/api/ref-trv-cons/:id',
                method: 'PUT',
            },
        },
    ),
).factory('DataAccessRefPromo', ($resource) =>
    $resource(
        'feature', {}, {
            getPromos: {
                url: '/api/ref-promo/search',
                method: 'GET',
                isArray: true,
            },
            getPromo: {
                url: '/api/ref-promo/:id',
                method: 'GET',
            },
            postPromo: {
                url: '/api/ref-promo',
                method: 'POST',
            },
            putPromo: {
                url: '/api/ref-promo/:id',
                method: 'PUT',
            },
            delPromo: {
                url: '/api/ref-promo/:id',
                method: 'DELETE',
            },
            getPromoCategories: {
                url: '/api/ref-promo-categories/search',
                method: 'GET',
                isArray: true,
                headers: {'x-order-by': 'name'},
            },
            postPromoCategory: {
                url: '/api/ref-promo-categories',
                method: 'POST',
            },
            putPromoCategory: {
                url: '/api/ref-promo-categories/:id',
                method: 'PUT',
            },
            delPromoCategory: {
                url: '/api/ref-promo-categories/:id',
                method: 'DELETE',
            },
            addPromoOnContract: {
                url: '/api/contracts/:id_contract/promo',
                method: 'PUT',
            },
        },
    ),
).factory('DataAccessRefVariables', ($resource) =>
    $resource(
        'variables', {}, {
            getVariables: {
                url: '/api/ref-variables',
                method: 'GET',
                isArray: true,
            },
            getVariable: {
                url: '/api/ref-variables/:id',
                method: 'GET',
            },
            addVariable: {
                url: '/api/ref-variables',
                method: 'POST',
            },
            updateVariable: {
                url: '/api/ref-variables/:id',
                method: 'PUT',
            },
            delVariable: {
                url: '/api/ref-variables/:id',
                method: 'DELETE',
            },
        },
    ),
).factory('DataAccessVariables', ($resource) =>
    $resource(
        'all', {}, {
            get: {
                url: '/api/get/:variables',
                method: 'GET',
            },
        },
    ),
).factory('DataAccessRefOrganization', ($resource) =>
    $resource(
        'organizations', {}, {
            getOrganizations: {
                url: '/api/organizations',
                method: 'GET',
                isArray: true,
            },
            getOrganization: {
                url: '/api/organizations/:id',
                method: 'GET',
            },
            addOrganization: {
                url: '/api/organizations',
                method: 'POST',
            },
            updateOrganization: {
                url: '/api/organizations/:id',
                method: 'PUT',
            },
        },
    ),
).factory('DataAccessRefTurpe', ($resource) =>
    $resource(
        'turpe', {}, {
            getTurpe: {
                url: '/api/ref-turpe',
                method: 'GET',
                isArray: true,
            },
            addTurpe: {
                url: '/api/ref-turpe',
                method: 'POST',
            },
            updateTurpe: {
                url: '/api/ref-turpe/:id',
                method: 'PUT',
            },
            delTurpe: {
                url: '/api/ref-turpe/:id',
                method: 'DELETE',
            },
        },
    ),
).factory('DataAccessRefTaxBeneficiary', ($resource) =>
    $resource(
        'organizations', {}, {
            getTaxBeneficiaries: {
                url: '/api/ref-tax-beneficiary',
                method: 'GET',
                isArray: true,
            },
            addTaxBeneficiary: {
                url: '/api/ref-tax-beneficiary',
                method: 'POST',
            },
            updateTaxBeneficiary: {
                url: '/api/ref-tax-beneficiary/:id',
                method: 'PUT',
            },
        },
    ),
).factory('DataAccessCampaigns', ($resource) =>
    $resource(
        'feature', {}, {
            getCampaigns: {
                url: '/api/campaigns?withRelated=emails,visits',
                method: 'GET',
                isArray: true,
            },
            getCampaign: {
                url: '/api/campaigns/:id',
                method: 'GET',
            },
            postCampaign: {
                url: '/api/campaigns',
                method: 'POST',
            },
            putCampaign: {
                url: '/api/campaigns/:id',
                method: 'PUT',
            },
            delCampaign: {
                url: '/api/campaigns/:id',
                method: 'DELETE',
            },
        },
    ),
).factory('DataAccessMedias', ($resource) =>
    $resource(
        'feature', {}, {
            getImages: {
                url: '/uploads/website-extras/images/',
                method: 'GET',
                isArray: true,
            },
            deleteImage: {
                url: '/uploads/website-extras/images/:id',
                method: 'DELETE',
            },
            deleteObject: {
                url: '/uploads/:bucket/:dir/:id',
                method: 'DELETE',
            },
        },
    ),
).factory('DataAccessInvoices', ($resource) =>
    $resource(
        'all', {}, {
            getContractInvoices: {
                url: '/api/contracts/:id_contract/invoices',
                method: 'GET',
                isArray: true,
            },
            getInvoices: {
                url: '/api/invoices/search?withRelated=payments,reversed,fees',
                method: 'GET',
                isArray: true,
                headers: {
                    'x-in': 'status=50,54,96,55,75,502',
                    'x-order-by': '-id',
                },
            },
            lastInvoice: {
                url: '/api/invoices/search',
                method: 'GET',
                isArray: true,
                headers: {
                    'x-in': 'status=54,50,96;type=REG,REG_FINAL',
                    'x-order-by': '-invoice_date',
                    'x-limit': 1,
                },
            },
            resendEmail: {
                url: '/api-user/invoices/:id_invoice/email',
                method: 'POST',
            },
        },
    ),
).factory('Tokens', ($resource) =>
    $resource(
        'resource', {}, {
            getToken: {
                url: '/tokens',
                method: 'POST',
            },
            createToken: {
                url: '/api-content/tokens',
                method: 'POST',
            },
        },
    ),
).factory('Tariff', ($resource) =>
    $resource(
        'tariff', {}, {
            getTariffForContract: {
                url: '/api/contracts/:idContract/tariff',
                method: 'GET',
            },
            simulationV1: {
                method: 'POST',
                url: '/api/tariff-simulation',
            },
            simulationV2: {
                method: 'POST',
                url: '/api/tariff-simulation/v2',
            },
        },
    ),
).factory('TimetableGeneration', ($resource) =>
    $resource(
        'tariff', {}, {
            firstV1: {
                url: '/api-user/contracts/:idContract/timetable',
                method: 'POST',
                isArray: true,
            },
            firstV2: {
                url: '/api-user/contract/:idContract/timetable/first',
                method: 'POST',
                isArray: true,
            },
            regenFirstV2: {
                url: '/api-user/contract/:idContract/timetable/first',
                method: 'PUT',
                isArray: true,
            },
            regenV1: {
                url: '/api-user/contracts/:idContract/timetable-regen?replace=true&precisely=:precisely',
                method: 'POST',
                isArray: true,
            },
            regenV2: {
                url: '/api-user/contract/:idContract/timetable?replace=true&precisely=:precisely',
                method: 'PUT',
                isArray: true,
            },
            nextV1: {
                method: 'POST',
                url: '/api-user/contracts/:idContract/next-timetable',
                isArray: true,
            },
            nextV2: {
                method: 'POST',
                url: '/api-user/contract/:idContract/timetable/next',
                isArray: true,
            },
            draftTimetableV1: {
                url: '/api-user/contractdrafts/:idContract/timetable',
                method: 'POST',
                isArray: true,
            },
            draftTimetableV2: {
                url: '/api-user/contractdraft/:idContract/timetable/simu',
                method: 'POST',
                isArray: true,
            },
        },
    ),
).factory('Rules', ($resource) =>
    $resource(
        'all', {}, {
            monthlyBilling: {
                url: '/rules/process-rules/monthly-billing',
                method: 'POST',
            },
            paymentsOdoo: {
                url: '/rules/process-rules/odoo-sync-payments',
                method: 'POST',
            },
            launch: {
                url: '/rules/process-rules/:rule',
                method: 'POST',
            },
            processOdooForTax: {
                url: '/rules/process-rules/odoo-sync-tax-declaration',
                method: 'POST',
            },
        },
    ),
).factory('Navigation', ($resource) =>
    $resource(
        'all', {}, {
            daily: {
                url: '/api-content/navigation-summary/daily',
                method: 'GET',
                isArray: true,
            },
            day: {
                url: '/api-content/navigation-summary/day',
                method: 'GET',
                isArray: true,
            },
            lastConnection: {
                url: '/api-content/last-connection/:id_account',
                method: 'GET',
            },
        },
    ),
).factory('Contacts', ($resource) =>
    $resource(
        'all', {}, {
            getContacts: {
                url: '/api-content/client-contacts/search',
                method: 'GET',
            },
            logCall: {
                url: '/api-content/client-contacts-phone',
                method: 'POST',
            },
            logMail: {
                url: '/api-content/client-contacts-mail',
                method: 'POST',
            },
            updateMail: {
                url: '/api-content/client-contacts-mail/:id',
                method: 'PUT',
            },
            addAttachment: {
                url: '/api-content/client-contacts-mail/:id/attachments',
                method: 'POST',
            },
            deleteAttachment: {
                url: '/api-content/client-contacts-mail/:id/attachments',
                method: 'DELETE',
            },
            getPhoneContact: {
                url: '/api-content/client-contacts-phone/:id',
                method: 'GET',
            },
            updatePhoneContact: {
                url: '/api-content/client-contacts-phone/:id',
                method: 'PUT',
            },
        },
    ),
).factory('ContactsPaginated', ($resource) =>
    (additionalData = {}) =>
        $resource(
            'all', {}, {
                getContacts: {
                    url: '/api-content/client-contacts/search',
                    method: 'GET',
                    headers: {
                        'x-order-by': additionalData.orderBy,
                        'x-limit': additionalData.limit,
                        'x-offset': additionalData.offset || 0,
                    },
                },
            },
        ),
).factory('AdminComments', ($resource) =>
    $resource(
        'all', {}, {
            getComments: {
                url: '/api-content/admin-comments/:object',
                method: 'GET',
                isArray: true,
            },
            deleteComment: {
                url: '/api-content/admin-comments/:id',
                method: 'DELETE',
            },
            updateComment: {
                url: '/api-content/admin-comments/:id',
                method: 'PUT',
            },
            addComment: {
                url: '/api-content/admin-comments',
                method: 'POST',
            },
        },
    ),
).factory('NavigationErrors', ($resource) =>
    $resource(
        'all', {}, {
            daily: {
                url: '/api-content/nav-errors-summary/daily',
                method: 'GET',
                isArray: true,
            },
            list: {
                url: '/api-content/nav-errors',
                method: 'GET',
                isArray: true,
            },
            sendError: {
                url: '/api-content/nav-error',
                method: 'POST',
            },
        },
    ),
).factory('ApiAdmin', ($resource) =>
    $resource(
        'all', {}, {
            healthchecks: {
                url: '/api-admin/healthchecks',
                method: 'GET',
                isArray: true,
            },
            contactlists: {
                url: '/api-admin/mails/contactlist',
                method: 'GET',
                isArray: true,
            },
            addContactlist: {
                url: '/api-admin/mails/contactlist',
                method: 'POST',
            },
            contactsInCL: {
                url: '/api-admin/mails/contactlist/:id',
                method: 'GET',
                isArray: true,
            },
            addContactsToCL: {
                url: '/api-admin/mails/contactlist/:id/contacts',
                method: 'POST',
            },
            getMetadata: {
                url: '/api-admin/mails/metadata',
                method: 'GET',
                isArray: true,
            },
            addMetadata: {
                url: '/api-admin/mails/metadata',
                method: 'POST',
            },
            getRequestTypes: {
                url: '/api-admin/jira/servicedesk/project/requesttype/search',
                method: 'GET',
                isArray: true,
            },
            getZendeskB2gTopics: {
                url: '/api-admin/zendesk-b2g/topics',
                method: 'GET',
                isArray: true,
            },
            createZendeskB2gTicket: {
                url: '/api-admin/zendesk-b2g/ticket',
                method: 'POST',
            },
            fetchZendeskB2gTickets: {
                url: '/api-admin/zendesk-b2g/tickets',
                method: 'GET',
            },
            updateZendeskB2gTicketStatus: {
                url: '/api-admin/zendesk-b2g/ticket/:id',
                method: 'PUT',
            },
            getZendeskB2gTicketComments: {
                url: '/api-admin/zendesk-b2g/ticket/:id/comments',
                method: 'GET',
            },
            createZendeskB2gTicketComment: {
                url: '/api-admin/zendesk-b2g/ticket/:id/comment',
                method: 'POST',
            },
            getDropdownChoices: {
                url: '/api-admin/jira/servicedesk/project/dropdown/options?project=:project&field=:field',
                method: 'GET',
                isArray: true,
            },
            getIssueTransitions: {
                url: '/api-admin/jira/issue/:idIssue/transition',
                method: 'GET',
            },
            performIssueTransition: {
                url: '/api-admin/jira/issue/:idIssue/transition',
                method: 'POST',
            },
            createJiraIssue: {
                method: 'POST',
                url: '/api-admin/jira/project/:projectKey/issue',
            },
            updateJiraIssue: {
                method: 'PUT',
                url: '/api-admin/jira/project/:projectKey/issue/:idIssue',
            },
            updateJiraIssueStatus: {
                method: 'PUT',
                url: '/api-admin/jira/project/:idProject/issue/:idIssue/status/:idStatus',
            },
            getCapAssignation: {
                method: 'GET',
                url: '/api-admin/cap/today',
            },
            getIssueComments: {
                method: 'GET',
                url: '/api-admin/jira/issue/:idIssue/comments',
                isArray: true,
            },
            getComplaintComments: {
                method: 'GET',
                url: '/api-admin/jira/issue/:idIssue/complaint-comments',
                isArray: true,
            },
            postIssueComment: {
                method: 'POST',
                url: '/api-admin/jira/issue/:idIssue/comment',
            },
            postTemporaryConnectionRequest: {
                method: 'POST',
                url: '/api-admin/temporary-connection-request',
            },
            updateTemporaryConnectionRequest: {
                method: 'PUT',
                url: '/api-admin/temporary-connection-request/:id',
            },
            getJiraStatusHistoryAndPublicComments: {
                method: 'GET',
                url: '/api-admin/jira/issue/:idIssue/status-history-public-comments',
            },
            checkParsingsToProcess: {
                method: 'POST',
                url: '/api-admin/batch-parsing-generation',
            },
            draftEligibilityBatch: {
                method: 'POST',
                url: '/api-admin/batch/draft-eligibility',
            },
            getBulkPurchaseClientDetail: {
                url: '/api-admin/bulk-purchase-client/:customer_id/details',
                method: 'GET',
            },
            getTransactionalEmailContent: {
                url: '/api-admin/ogc-external/transactional-email-content',
                method: 'GET',
            },
            listImportableContracts: {
                url: '/api-admin/import/list',
                method: 'GET',
                isArray: true,
            },
            importContract: {
                url: '/api-admin/import/contract',
                method: 'POST',
            },
            exportContract: {
                url: '/api-admin/export/contract/:id_contract',
                method: 'GET',
            },
            deleteImportFile: {
                url: '/api-admin/import',
                method: 'DELETE',
            },
            fetchMetadata: {
                url: '/api-admin/import/metadata',
                method: 'GET',
            },
            fetchTicketsCounts: {
                url: '/api-admin/zendesk/tickets-counts',
                method: 'GET',
            },
            userTicketsCounts: {
                url: '/api-admin/zendesk/user/:userId/tickets-counts',
                method: 'GET',
            },
            linkIssueForParsings: {
                url: '/api-admin/parsing-generations/jira/:issueId/attach',
                method: 'POST',
            },
            createIssueForParsings: {
                url: '/api-admin/parsing-generations/jira/new',
                method: 'POST',
            },
            sendMailFis: {
                url: '/api-admin/contract/:id_contract/send-fis-email',
                method: 'POST',
            },
            metricDashboards: {
                url: '/api-admin/metrics/dashboards',
                method: 'GET',
                isArray: false,
            },
            reSendTemplatedEmail: {
                url: '/api-admin/resend-templated-email/:id',
                method: 'POST',
            },
            listContractS3Timetables: {
                url: '/api-admin/contracts/:id_contract/list-s3-timetables',
                method: 'GET',
                isArray: true,
            },
            newSendInBlueSubscriptionList: {
                url: '/api-admin/sendinblue-subscriptions',
                method: 'POST',
            },
            getContactListDetails: {
                url: '/api-admin/contact-list-details/:id',
                method: 'GET',
            },
            sendConsentsReminderEmail: {
                url: '/api-admin/drafts/:id_draft_basic/send-consents-reminder-email',
                method: 'POST',
            },
            sendQuotationEmail: {
                url: '/api-admin/draft/:id_draft_basic/send-quotation-email',
                method: 'POST',
            },
            getContractOdooBalance: {
                url: '/api-admin/contracts/:id_contract/odoo-balance',
                method: 'GET',
                isArray: true,
            },
            synchroMetaInvoiceNumberWithOdoo: {
                url: '/api-admin/test-utils/reset-meta-invoice-number-for-odoo',
                method: 'POST',
                isArray: true,
            },
            processIrrecoverabilityCertificates: {
                url: '/api-admin/batches/irrecoverability-certificates-payment',
                method: 'POST',
                isArray: true,
            },
            sendProviderOfferFisToEmail: {
                url: '/api-admin/emails/send-fis-email',
                method: 'POST',
            },
            synchSiretsWithOdoo: {
                url: '/api-admin/batches/sync-sirets-with-odoo',
                method: 'POST',
            },
        },
    ),
).factory('LandscapeQuestions', ($resource) =>
    $resource(
        '/api-user/landscape', {
            category: '@category',
            id_contract: '@id_contract',
            id_answer: '@id_answer',
            id_question: '@id_question',
        }, {
            getAll: {
                url: '/api-user/landscape?',
                method: 'GET',
                isArray: true,
            },
            getPopupQuestion: {
                url: '/api-user/landscape/popup/:id_question',
                method: 'GET',
            },
            search: {
                url: '/api-user/landscape/:id_contract/questions?category=:category',
                method: 'GET',
                isArray: true,
                category: '@cat',
            },
            saveAnswer: {
                url: '/api-user/landscape/:id_contract/answer',
                method: 'POST',
            },
            delAnswer: {
                url: '/api-user/landscape/:id_contract/answer/:id_answer',
                method: 'DELETE',
            },
            flush: {
                url: '/api-user/landscape/:id_contract/flush',
                method: 'DELETE',
            },
            flushAfter: {
                url: '/api-user/landscape/:id_contract/flush-after/:id_question',
                method: 'DELETE',
            },
        },
    ),
).factory('Confluence', ($resource) =>
    $resource(
        'all', {}, {
            getContent: {
                url: '/confluence/content?title=:title&expand=body.view',
                method: 'GET',
            },
        },
    ),
).factory('Healthchecks', ($resource) =>
    $resource(
        'all', {}, {
            getHCs: {
                url: '/api-content/healthchecks',
                method: 'GET',
                isArray: true,
            },
            getEnedisStatus: {
                url: '/api-content/healthchecks/enedis',
                method: 'GET',
            },
        },
    ),
).factory('Technical', ($resource) =>
    $resource(
        'all', {}, {
            checkVersion: {
                url: '/version',
                method: 'GET',
            },
            checkCertificate: {
                url: '/check-certificate',
                method: 'GET',
            },
        },
    ),
).factory('ApiBilling', ($resource) =>
    $resource(
        'all', {}, {
            contractCheckReadings: {
                url: '/api-billing/contract/:idContract/check-billable-reading',
                method: 'POST',
            },
            contractsCheckReadings: {
                url: '/api-billing/contract-batch/check-billable-reading',
                method: 'POST',
                isArray: true,
            },
            checkReadings: {
                url: '/api-billing/invoice/check-readings',
                method: 'POST',
            },
            createMisc: {
                url: '/api-billing/invoice/misc',
                method: 'POST',
                isArray: true,
            },
            checkFees: {
                url: '/api-billing/invoice/check-fees',
                method: 'POST',
                isArray: true,
            },
            mergeInvoice: {
                url: '/api-billing/invoice/:id_invoice/mergePeriods',
                method: 'POST',
            },
            extendInvoice: {
                url: '/api-billing/invoice/:id_invoice/extend',
                method: 'POST',
            },
            valuateInvoice: {
                url: '/api-billing/invoice/:id_invoice/valuate',
                method: 'POST',
            },
            prepareInvoice: {
                url: '/api-billing/invoice/:id_invoice/prepare',
                method: 'POST',
            },
            runInvoice: {
                url: '/api-billing/invoice/:id_invoice/run',
                method: 'POST',
            },
            reverseInvoice: {
                url: '/api-billing/invoice/:id_invoice/reverse?send=true',
                method: 'POST',
            },
            simulateTimetable: {
                url: '/api-billing/invoice/:id_invoice/simulate-timetable-regen',
                method: 'POST',
            },
            regenTimetable: {
                url: '/api-billing/invoice/:id_invoice/regen-timetable',
                method: 'POST',
            },
            b2bHandleParsed: {
                url: '/api-billing/invoice-b2b/handleParsed',
                method: 'POST',
            },
            massOperation: {
                url: '/api-billing/invoice-batch/:operation',
                method: 'POST',
                isArray: true,
            },
            unaffectedFees: {
                url: '/api/fees/search?withRelated=prm.contractsElec&status=UNAFFECTED',
                method: 'GET',
                isArray: true,
                headers: {
                    'x-limit': 30,
                    'x-offset': 0,
                },
            },
            affectFee: {
                url: '/api/fees/:id',
                method: 'PUT',
            },
            fetchMetaInvoiceInvoices: {
                url: '/api/meta-invoices/:id/invoices',
                method: 'GET',
                isArray: true,
            },
            createMetaInvoice: {
                url: '/api-billing/meta-invoice/batchCreate',
                method: 'POST',
            },
            valuateMetaInvoice: {
                url: '/api-billing/meta-invoice/:id_invoice/valuate',
                method: 'POST',
            },
            prepareMetaInvoice: {
                url: '/api-billing/meta-invoice/:id_invoice/prepare',
                method: 'POST',
            },
            simulateCompensationsMeta: {
                url: '/api-billing/meta-invoice/:id_meta_invoice/compensation-simulation',
                method: 'POST',
            },
            runCompensationsMeta: {
                url: '/api-billing/meta-invoice/:id_meta_invoice/compensation-run',
                method: 'POST',
            },
            runMetaInvoice: {
                url: '/api-billing/meta-invoice/:id_invoice/run?send=true',
                method: 'POST',
            },
            revertMetaInvoice: {
                url: '/api-billing/meta-invoice/:id_invoice/reverse',
                method: 'POST',
            },
            createPenalty: {
                url: '/api-billing/meta-invoice/:id_invoice/penalty',
                method: 'POST',
            },
            batchValuateMetaInvoice: {
                url: '/api-billing/meta-invoice/batchValuate',
                method: 'POST',
            },
            batchSimulateMetaInvoice: {
                url: '/api-billing/meta-invoice/batchPrepare',
                method: 'POST',
            },
            batchRunMetaInvoice: {
                url: '/api-billing/meta-invoice/batchRun',
                method: 'POST',
            },
            batchRevertMetaInvoice: {
                url: '/api-billing/meta-invoice/batchRevert',
                method: 'POST',
            },
            runMetaInvoices: {
                url: '/api-billing/meta-invoice/batch-processing/:operation',
                method: 'POST',
            },
            regenMetaPDF: {
                url: '/api-billing/meta-invoice/:id_meta_invoice/regen-pdf',
                method: 'POST',
            },
            checkToRegenMisc: {
                url: '/api-billing/invoice/check-to-regen-misc',
                method: 'POST',
            },
            valuateMetaCutoff: {
                url: '/api-billing/meta-invoice-cutoff/:id_invoice/valuate',
                method: 'POST',
            },
            fetchMetaCutoffInvoices: {
                url: '/api/meta-invoices-cutoff/:id/invoices',
                method: 'GET',
                isArray: true,
            },
            valuateInvoiceCutoff: {
                url: '/api-billing/invoice/:id_invoice/valuateCutoff',
                method: 'POST',
            },
            getMessagesNumber: {
                url: '/api-billing/info/messagesNumber',
                method: 'GET',
            },
        },
    ),
).factory('AdminContents', ($resource) =>
    $resource(
        'all', {}, {
            getContentForContentId: {
                url: '/api-content/administrable-contents/search?contentId=:contentId',
                method: 'GET',
                isArray: true,
            },
            deleteContent: {
                url: '/api-content/administrable-contents/:id',
                method: 'DELETE',
            },
            updateContent: {
                url: '/api-content/administrable-contents/:id',
                method: 'PUT',
            },
            addContent: {
                url: '/api-content/administrable-contents',
                method: 'POST',
            },
        },
    ),
).factory('CMS', ($resource) =>
    $resource(
        'all', {}, {
            searchContents: {
                url: '/api-content/cms-contents/search',
                method: 'GET',
                isArray: true,
                headers: {
                    'x-columns': 'page;contentId;description',
                },
            },
            fetchContent: {
                url: '/api-content/cms-contents/:id',
                method: 'GET',
            },
            addContent: {
                url: '/api-content/cms-contents',
                method: 'POST',
            },
            updateContent: {
                url: '/api-content/cms-contents/:id',
                method: 'PUT',
            },
            deleteContent: {
                url: '/api-content/cms-contents/:id',
                method: 'DELETE',
            },
            addContentVersion: {
                url: '/api-content/cms-contents/:id/version',
                method: 'POST',
            },
            updateContentVersion: {
                url: '/api-content/cms-contents/:id/version/:versionId',
                method: 'PUT',
            },
            deleteContentVersion: {
                url: '/api-content/cms-contents/:id/version/:versionId',
                method: 'DELETE',
            },
        },
    ),
).factory('ProDrafts', ($resource) =>
    $resource(
        'all', {}, {
            initDraft: {
                url: '/api/pro-draft-basic',
                method: 'POST',
            },
            getDraft: {
                url: '/api/pro-draft-basic/:id_draft_basic',
                method: 'GET',
            },
            updateDraft: {
                url: '/api/pro-draft-basic/:id_draft_basic',
                method: 'PUT',
            },
            eligibilityPce: {
                url: '/api-user/eligibility/pce/:id_pce?id_contract=:id_draft_basic&id_contract_gas=:id_contract_gas',
                method: 'GET',
            },
            transformDraft: {
                url: '/api-user/pro-draft-basic/:id_draft_basic/transformation',
                method: 'POST',
            },
        },
    ),
).factory('DraftsBasic', ($resource) =>
    $resource(
        'all', {}, {
            // DA
            removeSponsorOnDraft: {
                url: '/api/drafts/:id_draft_basic/sponsor',
                method: 'DELETE',
            },
            checkSponsorOnDraft: {
                url: '/api/drafts/:id_draft_basic/check-sponsor/:sponsor_id',
                method: 'GET',
            },
            checkPromoOnDraft: {
                url: '/api-user/drafts/:id_draft_basic/check-promo/:id_ref_promo',
                method: 'GET',
            },
            removePromoOnDraft: {
                url: '/api/drafts/:id_draft_basic/promo',
                method: 'DELETE',
            },
            modifyDraftOffer: {
                url: '/api/drafts/:id_draft_basic/offer',
                method: 'PUT',
            },
            updateDraftById: {
                url: '/api/drafts/:id_draft_basic',
                method: 'PUT',
            },
            getDraftById: {
                url: '/api/drafts/:id_draft_basic',
                method: 'GET',
            },
            claimDraft: {
                url: '/api/drafts/:id_draft_basic/claim',
                method: 'PUT',
            },
            initDraft: {
                url: '/api/my-draft?vendor=true',
                method: 'GET',
            },
            getDraftBasicRedirectUrl: {
                url: '/api/drafts/:id_draft_basic/redirect-url',
                method: 'GET',
            },
            // AU
            adjustMonthlyPaymentsEstimation: {
                url: '/api-user/draft-basic/:id_draft_basic/estimated/amendment',
                method: 'PUT',
            },
            initClientDraft: {
                url: '/api-user/accounts/:id_account/draft',
                method: 'GET',
            },
            generateMandate: {
                url: '/api-user/drafts/:id_draft_basic/mandate-redirect',
                method: 'GET',
            },
            refreshDraftOverdue: {
                url: '/api-user/drafts/:id_draft_basic/overdue-scoring',
                method: 'GET',
            },
            checkLandscapeRequired: {
                url: '/api-user/drafts/:id_draft_basic/landscape-required',
                method: 'GET',
            },
            changeDraftOwner: {
                url: '/api-user/drafts/:id_draft_basic/chown/:id_account',
                method: 'POST',
            },
            preshootUserDraft: {
                url: '/api-user/drafts/:id_draft_basic/pre-shoot',
                method: 'PUT',
            },
            bulkPurchaseCheckout: {
                url: '/api-user/drafts/:id_draft_basic/bulk-purchase-checkout',
                method: 'POST',
            },
            getCompanyInformation: {
                url: '/api-user/drafts/:id_draft_basic/siret/:siret',
                method: 'GET',
            },
            changeDraftAccountCategory: {
                url: `/api/drafts/:id_draft_basic/account-category`,
                method: 'PUT',
            },
            getDraftBasicIdForDraftElec: {
                url: `/api/drafts-elec/:id/id-draft-basic`,
                method: 'GET',
            },
        },
    ),
).factory('GovernmentPriceReductionPeriod', ($resource) =>
    $resource(
        'all', {}, {
            addAccountGovernmentPriceReductionPeriod: {
                url: '/api/account-government-price-reduction-period',
                method: 'POST',
            },
            updateAccountGovernmentPriceReductionPeriod: {
                url: '/api/account-government-price-reduction-period/:idPeriod',
                method: 'PUT',
            },
            deleteAccountGovernmentPriceReductionPeriod: {
                url: '/api/account-government-price-reduction-period/:idPeriod',
                method: 'DELETE',
            },
            addContractGovernmentPriceReductionPeriod: {
                url: '/api/contract-government-price-reduction-period',
                method: 'POST',
            },
            updateContractGovernmentPriceReductionPeriod: {
                url: '/api/contract-government-price-reduction-period/:idPeriod',
                method: 'PUT',
            },
            deleteContractGovernmentPriceReductionPeriod: {
                url: '/api/contract-government-price-reduction-period/:idPeriod',
                method: 'DELETE',
            },
            addCategoryGovernmentPriceReductionPeriod: {
                url: '/api/contract-category-government-price-reduction-period/',
                method: 'POST',
            },
            updateCategoryGovernmentPriceReductionPeriod: {
                url: '/api/contract-category-government-price-reduction-period/:idPeriod',
                method: 'PUT',
            },
            deleteCategoryGovernmentPriceReductionPeriod: {
                url: '/api/contract-category-government-price-reduction-period/:idPeriod',
                method: 'DELETE',
            },
        },
    ),
).factory('MetaPreliminaryAPI', ($resource) =>
    $resource(
        'all', {}, {
            cancelMetaPreliminary: {
                url: '/api/meta-invoices-preliminary/:id',
                method: 'DELETE',
            },
            valuateMetaPreliminary: {
                url: '/api-billing/meta-invoice-preliminary/:id/valuate',
                method: 'POST',
            },
            createMetaPreliminary: {
                url: '/api-billing/meta-invoice-preliminary/batchCreate',
                method: 'POST',
            },
            fetchMetaPreliminaryInvoices: {
                url: '/api/meta-invoices-preliminary/:id/invoices',
                method: 'GET',
                isArray: true,
            },
        },
    ),
).factory('APIExternalLbp', ($resource) =>
    $resource(
        'all', {}, {
            encryptToken: {
                url: '/api-external/lbp/jwt/encryptToken',
                method: 'POST',
            },
        },
    ),
).factory('JiraSearch', ($resource) => {
    return (additionalData = {}) =>
        $resource(
            'search', {}, {
                search: {
                    url: '/api-admin/jira/project/search',
                    method: 'GET',
                    isArray: true,
                    headers: {'x-order-by': additionalData.orderBy, 'x-limit': additionalData.limit},
                },
                searchPaginated: {
                    url: '/api-admin/jira/project/search',
                    method: 'GET',
                    headers: _.assign({
                        'x-order-by': additionalData.orderBy,
                        'x-limit': additionalData.limit,
                        'x-offset': additionalData.offset || 0,
                    }, getAdditionalDataValues(additionalData)),
                    transformResponse(data, headers) {
                        const response = {}
                        response.results = JSON.parse(data)
                        response.headers = headers()
                        return response
                    },
                },
                searchAssignedPaginated: {
                    url: '/api-admin/jira/csr-b2c/assigned',
                    method: 'GET',
                    headers: _.assign({
                        'x-order-by': additionalData.orderBy,
                        'x-limit': additionalData.limit,
                        'x-offset': additionalData.offset || 0,
                    }, getAdditionalDataValues(additionalData)),
                    transformResponse(data, headers) {
                        const response = {}
                        response.results = JSON.parse(data)
                        response.headers = headers()
                        return response
                    },
                },
                searchUnassignedPaginated: {
                    url: '/api-admin/jira/csr-b2c/unassigned',
                    method: 'GET',
                    headers: _.assign({
                        'x-order-by': additionalData.orderBy,
                        'x-limit': additionalData.limit,
                        'x-offset': additionalData.offset || 0,
                    }, getAdditionalDataValues(additionalData)),
                    transformResponse(data, headers) {
                        const response = {}
                        response.results = JSON.parse(data)
                        response.headers = headers()
                        return response
                    },
                },
                searchPostponedPaginated: {
                    url: '/api-admin/jira/csr-b2c/postponed',
                    method: 'GET',
                    headers: _.assign({
                        'x-order-by': additionalData.orderBy,
                        'x-limit': additionalData.limit,
                        'x-offset': additionalData.offset || 0,
                    }, getAdditionalDataValues(additionalData)),
                    transformResponse(data, headers) {
                        const response = {}
                        response.results = JSON.parse(data)
                        response.headers = headers()
                        return response
                    },
                },
            },
        )
})
